<ion-header>
  <ion-toolbar>
    <ion-title *ngIf="isNew" translate="NEW_MENU"></ion-title>
    <ion-title *ngIf="!isNew">
      Menu <span *ngIf="menu" [innerText]="'- ' + menu?.name"></span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button
        class="ion-text-capitalize btn-2"
        [color]="(menu && menu.menuStatus === 'DRAFT') ? 'danger' : 'success'"
        (click)="onPublishClick()"
      >
        {{ btnPublishText }}
      </ion-button>
      <ion-button class="ion-text-capitalize" (click)="onSaveClick()" translate="SAVE"></ion-button>
      <ion-button class="ion-text-capitalize" (click)="onCloseClick()" translate="CLOSE"></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="banner">

    <div
      class="thumbnail"
      *ngIf="menu?.menuIconImage?.url || selectedMenu?.menuIconImage?.url"
      [style.background-image]="'url(' + (menu?.menuIconImage?.url || selectedMenu?.menuIconImage?.url) + ')'">
  
      <!-- Change Image Overlay -->
      <div class="change-overlay" (click)="fileDropRef.click()">
        <ion-icon name="camera-outline"></ion-icon>
        <span>Change Image</span>
      </div>
  
      <!-- Hidden input for changing image -->
      <input
        type="file"
        #fileDropRef
        style="display: none"
        (change)="onImageSelection($event)"
        accept="image/png, image/gif, image/jpeg"
      />
    </div>
  
    <!-- Show uploader only if image not selected -->
    <div class="image-upload-wrapper" *ngIf="!menu?.menuIconImage?.url && !selectedMenu?.menuIconImage?.url">
      <div class="image-upload-bg">
        <div class="image-upload" sdDnd (fileDropped)="onImageSelection($event)">
          <input
            type="file"
            #fileDropRef
            id="fileDropRef"
            (change)="onImageSelection($event)"
            accept="image/png, image/gif, image/jpeg"
          />
          <ion-icon src="assets/icons/file_upload_black_24dp.svg"></ion-icon>
          <h3>Drag and drop file here <strong>or</strong></h3>
          <label for="fileDropRef" class="browse-btn">Browse for file</label>
        </div>
      </div>
    </div>
  </div>
  

  <!-- Form -->
  <form [formGroup]="form" class="smartdine-form">
    <ion-list>
  
      <ion-item *ngIf="!menuId" button lines="inset" class="template-selection-link" (click)="onMenuTemplatesClick()">
        <ion-icon slot="start" color="primary" name="documents-outline"></ion-icon>
        <ion-label translate="MENU_LABEL"></ion-label>
        <ion-input *ngIf="selectedMenu" class="ion-text-end selection-name" readonly [value]="selectedMenu.name"></ion-input>
        <div *ngIf="selectedMenu" class="indicator"></div>
      </ion-item>
  
      <!-- Menu Name (Required) -->
      <ion-item lines="inset">
        <ion-label position="">
          <span translate="MENU_NAME"></span><span class="required-star">*</span>
        </ion-label>
        <ion-input formControlName="name" placeholder="Enter menu name"></ion-input>
      </ion-item>
      <small *ngIf="form.get('name')?.touched && form.get('name')?.invalid" color="danger" class="error-text">
        Menu name is required.
      </small>
  
      <!-- Menu Code (Required) -->
      <ion-item lines="inset">
        <ion-label position="">
          <span translate="MENU_CODE"></span><span class="required-star">*</span>
        </ion-label>
        <ion-input formControlName="code" placeholder="Enter code"></ion-input>
      </ion-item>
      <small *ngIf="form.get('code')?.touched && form.get('code')?.invalid" color="danger" class="error-text">
        Menu code is required.
      </small>
  
      <!-- Description (Optional) -->
      <ion-item lines="inset">
        <ion-label position="stacked" translate="DESCRIPTION"></ion-label>
        <ion-input formControlName="description" placeholder="Describe your menu"></ion-input>
      </ion-item>
  
      <!-- Template Toggle (Optional) -->
      <ion-item lines="inset">
        <ion-label>
          <span translate="TEMPLATE"></span>
        </ion-label>
        <ion-toggle slot="end" formControlName="template"></ion-toggle>
      </ion-item>
      <small *ngIf="form.get('template')?.touched && form.get('template')?.invalid" class="error-text">
        Template selection is required.
      </small>
  
      <!-- Tags (Required) -->
      <ion-item lines="inset">
        <ion-label>
          <span translate="TAGS"></span><span class="required-star">*</span>
        </ion-label>
        <ion-select slot="end" multiple="true" formControlName="tags">
          <ion-select-option>Veg</ion-select-option>
          <ion-select-option>Egg</ion-select-option>
          <ion-select-option>Non Veg</ion-select-option>
          <ion-select-option>Beverage</ion-select-option>
        </ion-select>
      </ion-item>
      <small *ngIf="form.get('tags')?.touched && form.get('tags')?.invalid" class="error-text">
        Please select at least one tag.
      </small>
  
    </ion-list>
  </form>
  
</ion-content>
